import { createFileRoute, redirect } from "@tanstack/react-router";

import HouseholdDetail, { HOUSEHOLD_TABS, type HouseholdTab } from "../components/HouseholdDetail";

export const Route = createFileRoute("/households/$householdId/$tab")({
  beforeLoad: ({ params }) => {
    if (!HOUSEHOLD_TABS.includes(params.tab as HouseholdTab)) {
      throw redirect({
        to: "/households/$householdId/$tab",
        params: { householdId: params.householdId, tab: "settlements" },
        replace: true,
      });
    }
  },
  component: HouseholdRoute,
});

function HouseholdRoute() {
  const { householdId, tab } = Route.useParams();
  return <HouseholdDetail householdId={householdId} tab={tab as HouseholdTab} />;
}
